export const rejectionCodes = {
  0: "No Response",
  1: "Income too High",
  2: "Studying Abroad",
  3: "Other",
}
